import types from "../types"

export default {
  start: function processingStart(type, task, engine, model, query) {
    return {
      type: types.processingStart,
      processType: type,
      task,
      engine,
      model,
      query,
    }
  },
  complete: function processingComplete(type, task, engine, model, query) {
    return {
      type: types.processingComplete,
      processType: type,
      engine,
      task,
      model,
      query,
    }
  },
}
